import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import saveIcon from './icons/save.svg';

const SAVE = 'save';

export default class SaveUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    // Add save button to feature components.
    editor.ui.componentFactory.add( SAVE, locale => {
      const command = editor.commands.get( SAVE );
      const view = new ButtonView( locale );

      view.set( {
        label: t( 'Save' ),
        icon: saveIcon,
        tooltip: true,
        withText: true,
        keystroke: 'CTRL+S',
        class:"toolbar-save"
      } );

      view.bind( 'isEnabled' ).to( command, 'isEnabled' );

      // Execute command.
      this.listenTo( view, 'execute', () => editor.execute( SAVE ) );

      return view;
    } );
  }
}
